(() => {
  if (customElements.get('sigsag-credit')) return;
  class SigsagCredit extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      if (this.dataset.context === 'cart') {
        this.bound = true;
        const scope = this.closest('.shopify-section') || document;
        const prices = scope.querySelector('[data-cart-prices]');
        if (!prices) return;
        this.refresh = async () => {
          const sequence = this.sequence = (this.sequence || 0) + 1;
          this.setAttribute('aria-busy', 'true');
          this.querySelector('[data-credit-estimate]')?.setAttribute('hidden', '');
          try {
            const url = new URL(this.dataset.refreshUrl, location.origin);
            url.searchParams.set('section_id', 'sigsag-credit-cart');
            const response = await fetch(url, {credentials:'same-origin', cache:'no-store'});
            if (!response.ok) throw new Error('Credit estimate unavailable');
            const html = new DOMParser().parseFromString(await response.text(), 'text/html');
            const fresh = html.querySelector('sigsag-credit');
            if (sequence !== this.sequence || !this.isConnected) return;
            if (fresh) this.replaceWith(fresh);
            else this.hidden = true;
          } catch {
            this.hidden = true;
          } finally {
            this.removeAttribute('aria-busy');
          }
        };
        this.observer = new MutationObserver(() => {
          clearTimeout(this.refreshTimer);
          this.refreshTimer = setTimeout(this.refresh, 100);
        });
        this.observer.observe(prices.parentElement, {childList:true, characterData:true, subtree:true});
        return;
      }
      if (this.dataset.context !== 'product') return;
      this.bound = true;
      this.form = document.getElementById(this.dataset.formId);
      this.amount = this.querySelector('[data-credit-estimate]');
      if (!this.form || !this.amount) return;
      try { this.variants = JSON.parse(this.querySelector('[data-credit-variants]').textContent); } catch { return; }
      this.update = () => {
        const id = String(this.form.querySelector('[name="id"]')?.value || '');
        const selected = this.variants.find(variant => String(variant.id) === id);
        if (!selected) return;
        this.hidden = !selected.ships;
        if (this.hidden) return;
        const quantity = Math.max(1, Math.floor(Number(this.form.querySelector('[name="quantity"]')?.value) || 1));
        const reward = Math.round(selected.price * quantity * Number(this.dataset.rate) / 100);
        const formatted = new Intl.NumberFormat(document.documentElement.lang?.startsWith('es') ? 'es-MX' : document.documentElement.lang || 'en', {style:'currency',currency:this.dataset.currency}).format(reward / 100) + ' ' + this.dataset.currency;
        const text = this.dataset.estimateTemplate.replace('__AMOUNT__', formatted);
        if (this.amount.textContent !== text) this.amount.textContent = text;
      };
      this.onChange = () => queueMicrotask(this.update);
      this.form.addEventListener('input', this.onChange);
      this.form.addEventListener('change', this.onChange);
      this.form.addEventListener('click', this.onChange);
      this.scope = this.closest('.t4s-product__info-container') || this.closest('.t4s-product-form__variants');
      this.price = this.scope?.querySelector('.t4s-product__price-review');
      if (this.price) { this.observer = new MutationObserver(this.update); this.observer.observe(this.price, {childList:true,characterData:true,subtree:true}); }
      this.update();
    }
    disconnectedCallback() {
      clearTimeout(this.refreshTimer);
      this.sequence = (this.sequence || 0) + 1;
      this.observer?.disconnect();
      this.form?.removeEventListener('input', this.onChange);
      this.form?.removeEventListener('change', this.onChange);
      this.form?.removeEventListener('click', this.onChange);
      this.bound = false;
    }
  }
  customElements.define('sigsag-credit', SigsagCredit);
})();
